import script from "./WorkingPages.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkingPages.vue?vue&type=script&setup=true&lang=js"

import "./WorkingPages.vue?vue&type=style&index=0&id=05aa2b3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05aa2b3c"]])

export default __exports__